import { render, staticRenderFns } from "./data.vue?vue&type=template&id=6cbc4e6a&scoped=true"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc4e6a",
  null
  
)

export default component.exports